export const EVENT_CONSTS = {
    GET_EVENTS: "GET_EVENTS",
    CREATE_EVENT: "CREATE_EVENT",
    GET_EVENT_BY_ID: "GET_EVENT_BY_ID",
    UPDATE_EVENT_BY_ID: "UPDATE_EVENT_BY_ID",
    DELETE_EVENT_BY_ID: "DELETE_EVENT_BY_ID",
};
